import React from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from 'react-confirm';
import Modal from './Modal';
import Button, { BUTTON_POSITION, BUTTON_TYPE } from './Button';

const Confirm = ({okLabel = 'OK', cancelLabel = 'Cancel', title = 'Confirm', confirmation, show, proceed = () => {}, enableEscape = true} = {}) => {
  return (
    <Modal animation={false} show={show} onHide={() => proceed(false)} backdrop={enableEscape ? true : 'static'} keyboard={enableEscape}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        {confirmation}
      </Modal.Body>
      <Modal.Footer>
        <Button.Panel>
          <Button position={BUTTON_POSITION.LEFT} variant={BUTTON_TYPE.PRIMARY} onClick={() => proceed(true)}>{okLabel}</Button>
          <Button position={BUTTON_POSITION.RIGHT} variant={BUTTON_TYPE.SECONDARY} onClick={() =>proceed(false)}>{cancelLabel}</Button>
        </Button.Panel>
      </Modal.Footer>
    </Modal>
  )
}

Confirm.propTypes = {
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  title: PropTypes.string,
  confirmation: PropTypes.string,
  show: PropTypes.bool,
  proceed: PropTypes.func,
  enableEscape: PropTypes.bool,
}

export default confirmable(Confirm);

export const confirm = (title, okLabel, cancelLabel, confirmation = '') => {
  return createConfirmation(confirmable(Confirm))({title, okLabel, cancelLabel, confirmation});
};